var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.761,
    height: 19.165,
    viewBox: "0 0 18.761 19.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "query",
    transform: "translate(-389.33 -389.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11972",
    "data-name": "Path 11972",
    d: "M398.712,389.9a9.372,9.372,0,1,1-3.594,18.028.652.652,0,0,0-.383-.017q-2.044.536-4.088,1.1a.93.93,0,0,1-1.2-1.209c.349-1.277.69-2.563,1.022-3.841a.463.463,0,0,0-.051-.315,9.019,9.019,0,0,1-.971-5.714,9.173,9.173,0,0,1,5.944-7.417A8.838,8.838,0,0,1,398.712,389.9Zm-7.443,17.279c.119-.026.187-.043.247-.06l3.219-.869a.805.805,0,0,1,.6.034,7.78,7.78,0,1,0-4.369-7.656,7.816,7.816,0,0,0,1.081,4.65.715.715,0,0,1,.1.588c-.162.6-.315,1.192-.477,1.788C391.541,406.14,391.414,406.634,391.269,407.179Z",
    transform: "translate(0)",
    fill: "rgba(248,225,247,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11973",
    "data-name": "Path 11973",
    d: "M461.727,447.307c-.554-.068-1.082-.136-1.627-.2a2.6,2.6,0,0,1,.7-1.669,3.16,3.16,0,0,1,2.146-1.047,3.8,3.8,0,0,1,2.665.562,3.339,3.339,0,0,1,.852.877,2.122,2.122,0,0,1-.247,2.7c-.341.366-.724.7-1.09,1.039-.068.06-.136.119-.213.179a1.6,1.6,0,0,0-.69,1.473,1.377,1.377,0,0,1-.009.179H462.6a2.676,2.676,0,0,1,.562-2.154c.358-.375.766-.707,1.158-1.065.119-.1.238-.2.349-.315a1.164,1.164,0,0,0-.255-1.925,1.787,1.787,0,0,0-2.521.886C461.829,446.975,461.786,447.129,461.727,447.307Z",
    transform: "translate(-64.744 -49.82)",
    fill: "rgba(248,225,247,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11974",
    "data-name": "Path 11974",
    d: "M491.28,534.6c0,.571,0,1.116-.009,1.669,0,.034-.077.1-.119.1-.545.008-1.09.008-1.652.008V534.6Z",
    transform: "translate(-91.64 -132.378)",
    fill: "rgba(248,225,247,0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryicon);
export default __webpack_public_path__ + "static/media/query icon.8ca3ba00855093f51f2515fdc98205c2.svg";
export { ForwardRef as ReactComponent };